<template>
  <div class="ba-flex ba-justify-center ba-text-sm ba-font-inter-regular">
    <!-- PREV BUTTON -->
    <button
      :disabled="skipValue === 0"
      type="button"
      class="ba-flex ba-justify-center ba-items-center ba-w-8 ba-h-8 ba-mr-2 ba-leading-none ba-select-none ba-opacity-90 hover:ba-opacity-100"
      @click="onPreviousPageClick"
    >
      <i class="fal fa-chevron-left" />
    </button>
    <!-- ============================== -->
    <!-- NEXT BUTTON -->
    <button
      :disabled="mailsCount === lastLetterOnPageIndex"
      type="button"
      class="ba-flex ba-justify-center ba-items-center ba-w-8 ba-h-8 ba-mr-2 ba-leading-none ba-select-none ba-opacity-90 hover:ba-opacity-100"
      @click="onNextPageClick"
    >
      <i class="fal fa-chevron-right" />
    </button>
    <!-- ============================== -->

    <span class="ba-self-end ba-mr-2 ba-pb-2 ba-leading-none ba-select-none"
      >{{ skipValue + 1 }} - {{ lastLetterOnPageIndex }} из ({{
        mailsCount
      }})</span
    >
  </div>
</template>

<script>
export default {
  props: {
    mailsCount: { type: Number, required: true },
    skipValue: { type: Number, required: true },
  },
  data() {
    return {
      paginaton: [2, 3, 4],
      active: 1,
      currentPage: 1,
    };
  },
  computed: {
    lastLetterOnPageIndex() {
      const defaultIndex = this.skipValue + 1 + 10;
      if (defaultIndex < this.mailsCount) return defaultIndex;
      return this.mailsCount;
    },
  },
  methods: {
    onNextPageClick() {
      this.$emit("nextPageClick");
    },
    onPreviousPageClick() {
      this.$emit("previousPageClick");
    },
  },
};
</script>
